import { RequiredMark } from "./required-mark";
import styles from "./working-days.module.css";

/** ISO weekdays, Monday first — the order a week is read in here. */
const DAYS: readonly { day: number; short: string; name: string }[] = [
  { day: 1, short: "Mon", name: "Monday" },
  { day: 2, short: "Tue", name: "Tuesday" },
  { day: 3, short: "Wed", name: "Wednesday" },
  { day: 4, short: "Thu", name: "Thursday" },
  { day: 5, short: "Fri", name: "Friday" },
  { day: 6, short: "Sat", name: "Saturday" },
  { day: 7, short: "Sun", name: "Sunday" },
];

/**
 * Which days the practice works (QA4-D5) — seven toggles, Monday first, each
 * pressed or not. Sign-up asks it, and Practice details edits it; a location
 * opened afterwards starts with these days as its opening hours.
 */
export function WorkingDays({
  value,
  onChange,
  label = "Working days",
  required = false,
  disabled = false,
  testId,
}: {
  /** ISO weekdays, 1 = Monday … 7 = Sunday. */
  value: readonly number[];
  onChange: (days: number[]) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  testId: string;
}): React.JSX.Element {
  const toggle = (day: number): void =>
    onChange(
      value.includes(day) ? value.filter((d) => d !== day) : [...value, day].sort((a, b) => a - b),
    );

  return (
    <div className={styles.field} role="group" aria-label={label} data-testid={testId}>
      <span className={styles.label}>
        {label}
        {required && <RequiredMark />}
      </span>
      <div className={styles.days}>
        {DAYS.map(({ day, short, name }) => (
          <button
            key={day}
            type="button"
            className={value.includes(day) ? styles.on : styles.off}
            aria-pressed={value.includes(day)}
            aria-label={name}
            disabled={disabled}
            onClick={() => toggle(day)}
            data-testid={`${testId}-${String(day)}`}
          >
            {short}
          </button>
        ))}
      </div>
    </div>
  );
}
